import { render, staticRenderFns } from "./LimeiqLogo.vue?vue&type=template&id=0abc8182&scoped=true"
import script from "./LimeiqLogo.vue?vue&type=script&lang=js"
export * from "./LimeiqLogo.vue?vue&type=script&lang=js"
import style0 from "./LimeiqLogo.vue?vue&type=style&index=0&id=0abc8182&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0abc8182",
  null
  
)

export default component.exports